import { Box, Flex } from '@digibee/beehive-ui';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { EnvironmentType } from '../EnvironmentIndicator';

import { StoreRootState } from '~/scenes/Monitor/types/StoreRootState';
import { ENV_INDICATOR_COLORS } from '~/scenes/Others/scenes/App/Operation/components/Header/components/EnvironmentSelect';

type EnvironmentTagProps = {
  environment?: string;
};

export const EnvironmentTag = ({ environment }: EnvironmentTagProps) => {
  const { application } = useSelector<
    StoreRootState,
    Pick<StoreRootState, 'application'>
  >(state => state);

  // eslint-disable-next-line no-underscore-dangle
  const _environment = environment || application.environment;

  const environments = application.environments?.allNames?.asMutable({
    deep: true
  });

  const sortedEnvs = useMemo(() => {
    if (!environments.length) return [];

    const envNames = environments;

    const prodIndex = envNames.indexOf('prod');
    if (prodIndex > -1) {
      envNames.splice(prodIndex, 1);
      envNames.unshift('prod');
    }
    const testIndex = envNames.indexOf('test');
    if (testIndex > -1) {
      envNames.splice(testIndex, 1);
      envNames.splice(1, 0, 'test');
    }
    return envNames;
  }, [environments]);

  const selectedEnv = {
    idx: sortedEnvs.findIndex(env => env === _environment),
    name: _environment as EnvironmentType
  };

  return (
    <Flex
      css={{
        display: 'flex',
        padding: '1px 7px 1px 3px',
        alignItems: 'center',
        gap: '4px',
        borderRadius: '20px',
        border: '1px solid var(--colors-neu300)',
        background: 'white',
        fontSize: '14px',
        lineHeight: '20px',
        fontWeight: 400,
        color: 'var(--colors-neu500)',
        textTransform: 'capitalize',
        fontFamily: 'var(--fonts-display)',
        width: 'fit-content'
      }}
    >
      <Box
        css={{
          width: '16px',
          height: '16px',
          borderRadius: '100%'
        }}
        className={ENV_INDICATOR_COLORS[selectedEnv.name]}
      />
      {selectedEnv.name}
    </Flex>
  );
};
